import { clickType } from "@/types/generalTypes";
import React from "react";

function Telegram({ className, onClick }: clickType) {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.827393 10.9997C0.827393 12.3065 1.08478 13.6005 1.58486 14.8078C2.08494 16.0151 2.81792 17.112 3.74194 18.0361C4.66597 18.9601 5.76295 19.6931 6.97024 20.1931C8.17754 20.6932 9.47152 20.9506 10.7783 20.9506C12.0851 20.9506 13.379 20.6932 14.5863 20.1931C15.7936 19.6931 16.8906 18.9601 17.8146 18.0361C18.7387 17.112 19.4716 16.0151 19.9717 14.8078C20.4718 13.6005 20.7292 12.3065 20.7292 10.9997C20.7292 9.69295 20.4718 8.39898 19.9717 7.19168C19.4716 5.98438 18.7387 4.8874 17.8146 3.96338C16.8906 3.03935 15.7936 2.30637 14.5863 1.80629C13.379 1.30622 12.0851 1.04883 10.7783 1.04883C9.47152 1.04883 8.17754 1.30622 6.97024 1.80629C5.76295 2.30637 4.66597 3.03935 3.74194 3.96338C2.81792 4.8874 2.08494 5.98438 1.58486 7.19168C1.08478 8.39898 0.827393 9.69295 0.827393 10.9997Z"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1444 5.92285L14.3089 16.7835L9.71936 12.0737L4.28369 10.9355L15.1444 5.92285Z"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6936 11.6465L8.51037 16.362L11.4998 13.8854"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.71484 12.0504L11.4563 10.6572"
        stroke="#686868"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Telegram;
